import { Fragment, useState } from "react"
import { DefaultRoute } from "../router/routes"

import ReactPaginate from 'react-paginate'

import { yupResolver } from "@hookform/resolvers/yup";

import { utils, writeFile  } from 'xlsx'
import { Badge } from "reactstrap";
import { t } from "i18next";

import news from "@src/assets/images/lesson/News.png"
import book from "@src/assets/images/lesson/Book.png"
import exam from "@src/assets/images/lesson/Exam.png"
import example from "@src/assets/images/lesson/Material.png"
import file from "@src/assets/images/lesson/Lecture.png"
import homework from "@src/assets/images/lesson/Homework.png"
import video from "@src/assets/images/lesson/Video.png"

import moment from 'moment'

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = (obj) => Object.keys(obj).length === 0

// ** Returns K format from a number
export const kFormatter = (num) => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)

// ** Converts HTML to string
export const htmlToString = (html) => html.replace(/<\/?[^>]+(>|$)/g, "")

export const moneyFormat = (value) =>
{
  let currency = Number(value ?? 0).toLocaleString('en-US')
  return currency
}


// ** Checks if the passed date is today
const isToday = (date) => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (date, format="YYYY-MM-DD") =>
{
  return moment(date).format(format)
}

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: "short", day: "numeric" }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: "numeric", minute: "numeric" }
  }

  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value))
}

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem("userData")
export const getUserData = () => JSON.parse(localStorage.getItem("userData"))

/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
  if (userRole === "admin") return DefaultRoute
  if (userRole === "client") return "/access-control"
  return "/login"
}

// ** React Select Theme Colors
export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#7367f01a", // for option hover bg-color
    primary: "#7367f0", // for selected option bg-color
    neutral10: "#7367f0", // for tags bg-color
    neutral20: "#ededed", // for input border-color
    neutral30: "#ededed" // for input hover border-color
  }
})

// React-select- н style
const targetHeight = 30;

export const ReactSelectStyles = {
  control: (base, state) => ({
    ...base,
    fontSize: '12px',
    minHeight: 'initial',
  }),
  valueContainer: (base) => ({
    ...base,
    height: 'auto',
    padding: '0 8px',
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: `${(targetHeight - 20 - 1 - 1) / 2}px`,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: `${(targetHeight - 20 - 1 - 1) / 2}px`,
  }),
  option: (provided, state) => ({
    ...provided,
    fontSize: '12px',
    padding: `${(targetHeight - 20 - 1 - 1) / 2}px`,
  }),
  menuPortal: provided => ({ ...provided, zIndex: 9999 }),
  menu: provided => ({ ...provided, zIndex: 9999 }),
  multiValue: (base) => ({
    ...base,
  })
};

// React-select- н style


export const ReactSelectStylesLesson = (skin) => {
  var theight = 40;
  // var theight = skin == 'dark' ? 40 : 20;
  return{
    control: (base, state) => ({
      ...base,
      minWidth: '199px!important',
      maxWidth: '200px!important',
      // maxWidth: '10,666666666dvw!important',
      width: '100%',
      // maxWidth: '12.5vw',
      // minWidth: '11.5vw',
      fontSize: '12px',
      minHeight: 'initial',
    }),
    valueContainer: (base) => ({
      ...base,
      height: 'auto',
      padding: '0 8px',
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: `${(theight - 20 - 1 - 1) / 2}px`,
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: `${(theight - 20 - 1 - 1) / 2}px`,
    }),
    option: (provided, state) => ({
      ...provided,
      fontSize: '12px',
      padding: `${(theight - 20 - 1 - 1) / 2}px`,
    }),
    menuPortal: provided => ({ ...provided, zIndex: 9999 }),
    menu: provided => ({ ...provided, zIndex: 9999 }),
    multiValue: (base) => ({
      ...base,
    })
  }
};

// {value: 'value1', label: 'label'} to ====> data
export const valueLabelToArray = (data) =>
{
  return data.map(
      (element) =>
      {
        return element.value
      }
  )
}

// value type хөрвүүлэх
export const valueTypeToInputType = value_type => {

    switch(value_type) {
        case 'boolean':
            return 'checkbox'
        case 'date':
            return 'date'
        case 'double':
            return 'number'
        case 'link':
            return 'text'
        // TODO: шалгах
        case 'multi-select':
            return 'checkbox'
        case 'multi-text':
            return 'textarea'
        case 'number':
            return 'number'
        case 'single-select':
            return 'option'
        default:
            return 'text'
    }
}

// ** Pagination Previous Component
export const Previous = () => {
  return (
    <Fragment>
      <span className='align-middle d-none d-md-inline-block'>{t('Өмнөх')}</span>
    </Fragment>
  )
}

// ** Pagination Next Component
export const Next = () => {
  return (
    <Fragment>
      <span className='align-middle d-none d-md-inline-block'>{t('Дараах')}</span>
    </Fragment>
  )
}

/**
 ** Datatable хуудаслалт
 * @param {Function} handlePagination Хуудас солих үед ажиллах функц
 * @param {String} searchValue Хайлт хийх утга
 * @param {String} pageNo Сонгосон хуудасны дугаар
 * @param {Array} filteredData Хайлтын дагуух дата
 * @param {String} rowsPerPage Хуудсанд харуулах датаны лимит
 * @param {String} total_count Нийт датаны тоо
*/
export function getPagination(handlePagination, pageNo, rowsPerPage, total_count, searchValue='', filteredData='') {
    const page_count = Math.ceil(total_count / rowsPerPage)
    var filtered_page_count = 1
    if(searchValue && searchValue.length) {
      filtered_page_count = Math.ceil(filteredData.length / rowsPerPage)
    }
    const CustomPagination = () => (
        <ReactPaginate
          previousLabel={<Previous size={15} />}
          nextLabel={<Next size={15} />}
          forcePage={
            searchValue.length
            ?
              (pageNo > filtered_page_count) ? (filtered_page_count !== 0 ? filtered_page_count - 1 : 0) : (pageNo !== 0 ? pageNo - 1 : 0)
            :
            (pageNo > page_count) ? 0 : (pageNo !== 0 ? pageNo - 1 : 0)
          }
          onPageChange={page => handlePagination(page)}
          pageCount={
            searchValue && searchValue.length
              ? filtered_page_count
              : page_count || 1
          }
          breakLabel={'...'}
          pageRangeDisplayed={2}
          marginPagesDisplayed={2}
          activeClassName={'active'}
          pageClassName={'page-item'}
          nextLinkClassName={'page-link'}
          nextClassName={'page-item next'}
          previousClassName={'page-item prev'}
          previousLinkClassName={'page-link'}
          pageLinkClassName={'page-link'}
          breakClassName='page-item'
          breakLinkClassName='page-link'
          containerClassName={'pagination react-paginate pagination-sm justify-content-end pe-1 mt-1'}
        />
    )
    return CustomPagination
}

/** form data-гийн field-ийн утга хоосон байвал null болгоно.
 * @param {object} datas
 */
 export const convertDefaultValue = (datas) => {
    for (let field in datas) {
      let value = datas[field]
      if (!value && typeof(value) != 'boolean') {
        datas[field] = null
      }
    }
  return datas
}

// return Validation
export const validate = (validation) => {
    const isValidation = {
      mode: "onTouched",
      reValidateMode: "onChange",
      resolver: yupResolver(validation),
    }
    return isValidation
}


/**
 * Converts table to CSV
 * @param {Array} downloadData татах гэж байгаа дата
 * @param {object} excelColumns баганы нэрийг монгол нэршилтэй болгох
*/
function convertArrayOfObjectsToCSV(downloadData, excelColumns) {
    let result

    const columnDelimiter = ','
    const lineDelimiter = '\n'

    const keys = Object.keys(downloadData[0])

    // Excel файлын баганын нэрийг криллээр болгох
    let excel_col_keys = []
    keys.forEach(key => {
        excel_col_keys.push(excelColumns[key])
    })

    result = ''
    result += excel_col_keys.join(columnDelimiter)
    result += lineDelimiter

    downloadData.forEach(item => {
        let ctr = 0
        keys.forEach(key => {
            if (ctr > 0) result += columnDelimiter

            result += item[key]

            ctr++
        })
        result += lineDelimiter
    })

    return result
}

/**
 * Downloads CSV
 * @param {Array} downloadData татах гэж байгаа дата
 * @param {object} excelColumns баганы нэрийг монгол нэршилтэй болгох
 * @param {String} filename хадгалах гэж байгаа файлын нэр
*/
export function downloadCSV(downloadData, excelColumns, filename='export')  {
    const link = document.createElement('a')

    let csv = convertArrayOfObjectsToCSV(downloadData, excelColumns)
    if (csv === null) return

    if (!csv.match(/^data:text\/csv/i)) {
        csv = `data:text/csv;charset=utf-8,${csv}`
    }

    link.setAttribute('href', encodeURI(csv))
    link.setAttribute('download', filename + '.csv')
    link.click()
}

/**
 * Downloads EXCEL
 * @param {Array} downloadData татах гэж байгаа дата
 * @param {object} excelColumns баганы нэрийг монгол нэршилтэй болгох
 * @param {String} filename хадгалах гэж байгаа файлын нэр
*/
export function donloadExcel(download_data, excelColumns, filename='export') {
    const keys = Object.keys(download_data[0])

    // Баганын нэрийг Монгол болгох хэсэг
    let excel_col_keys = []
    keys.forEach(key => {
        excel_col_keys.push(excelColumns[key])
    })

    /* generate worksheet and workbook */
    const worksheet = utils.json_to_sheet(download_data);
    const workbook = utils.book_new();
    utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // /* fix headers */
    utils.sheet_add_aoa(worksheet, [excel_col_keys], { origin: "A1" });

    return writeFile(workbook, filename + '.xlsx')
}

//string утгыг bool рүү хөрвүүлэх
export const stringToBoolean = (stringValue) => {
    if (typeof stringValue == "boolean") {
        return stringValue
    }
    else if (typeof stringValue === 'string') {
        switch(stringValue?.toLowerCase()?.trim()){
            case "true":
            case "1":
            return true;

            case "false":
            case "0":
            return false;

            default:
            return JSON.parse(stringValue);
        }
    }
    else {
        throw "Invalid input";
    }
}

export const generateLessonYear = ( year ) =>{

  var today = new Date();
  var now_year = today.getFullYear();
  const start_year = now_year - year
  const years = []

  for (var i = now_year; i >= start_year; i--) {
    var value = i + '-' + (i + 1)
    var check_years = { id: value, name: value }
    years.push(check_years);
  }
  // setYears(years)

  return years
}

export const get_ys_undes = () => {
  var datas = []
  const yas_undes = [
    "Халх",
    "Баяд",
    "Буриад",
    "Барга",
    "Дарьганга",
    "Дархад",
    "Дөрвөд",
    "Мянгад",
    "Захчин",
    "Өөлд",
    "Торгууд",
    "Үзэмчин",
    "Хамниган",
    "Харчин",
    "Хотгойд",
    "Цахар",
    "Казак",
    "Урианхай",
    "Хотон",
    "Сартуул",
    "Элжигэн",
    "Бусад",
  ]
  yas_undes.map((undes) => {
    var check_undes = { id: undes, name: undes }
    datas.push(check_undes)
  })
  return datas
}

export const get_admission_before = () => {
  return [
    "12-р ангиас",
    "Өөр хэлбэрийн сургуулиас",
    "Ажиллагсадаас",
    "Ажилгүйчүүдээс",
    "Их, дээд сургуулийн шилжилт/Монгол улс/",
    "Бүрэлдэхүүн сургууль институтийн хооронд шилжилт",
    "Шууд элсэлтээр",
    "Давхар мэргэжлээр",
    "Гадаадад суралцагчдаас",
    "Их, дээд сургуулийн шилжилт/Гадаад улс/",
    "Хичээл солилцооны системээс"
  ]
}

/** Боловсролын түвшин */
export const get_education_list = () => {
  const datas = []
  const lists = [
    "СӨБ",
    "Бага, суурь",
    "Бүрэн дунд",
    "Мэргэжлийн боловсрол",
    "Дээд боловсрол",
  ]
  lists.map((list, idx) => {
    var data = { id: idx+1, name: list }
    datas.push(data)
  })
  return datas
}

/** Өрөөний төрөл */
export const get_room_type = () => {
  const datas = []
  const lists = [
    'Лаборатор',
    'Лекц',
    'Семинар',
    'Бусад'
  ]
  lists.map((list, idx) => {
    var data = { id: idx+1, name: list }
    datas.push(data)
  })
  return datas
}

/* Өдрийн жагсаалт*/
export const get_day = () => {
  const datas = []
  const lists = [
    'Даваа',
    'Мягмар',
    'Лхагва',
    'Пүрэв',
    'Баасан',
    'Бямба',
    'Ням'
  ]
  lists.map((list, idx) => {
    var data = { id: idx+1, name: list }
    datas.push(data)
  })
  return datas
}

/*Хичээлийн түвшин*/
export const lesson_level = () => {
  const datas = []
  const list = [
    'Ерөнхий суурь хичээл',
    'Мэргэжлийн суурь хичээл',
    'Мэргэжлийн хичээл'
  ]
  list.map((list, idx) => {
    var data = {id: idx+1, name:list}
    datas.push(data)
  })
  return datas
}

/*Хичээлийн төрөл*/
export const lesson_type = () => {
  const datas = []
  const list = [
    'Заавал үзэх',
    'Сонгон судлах',
    'Дадлага',
    'Диплом'
  ]
  list.map((list, idx) => {
    var data ={id: idx+1, name:list}
    datas.push(data)
  })
  return datas
}

/* Цагийн жагсаалт*/
export const get_time = () => {
  const datas = []
  var idx = 0
  for(idx = 0; idx < 8; idx++)
  {
    var data = { id: idx+1, name: (idx+1).toString() +'-р пар' }
    datas.push(data)
  }
  return datas
}

/*Сургалтын төлбөрийн эхний үлдэгдэл*/
export const first_balance = () => {
  const datas = []
  const list = [
    'Төлбөрийн илүү',
    'Төлбөрийн дутуу'
  ]
  list.map((list, idx) => {
    var data ={id: idx+1, name:list}
    datas.push(data)
  })
  return datas
}

/*Гүйлгээний төрөл*/
export const get_BALANCE_FLAG = () => {
  const datas = []
  const list = [
    'Төлсөн төлбөр',
    'Буцаасан төлбөр'
  ]
  list.map((list, idx) => {
    var data ={id: idx+1, name:list}
    datas.push(data)
  })
  return datas
}


/*Сургалтын төлөвлөгөөний улирал*/
export const get_learningplan_season = () => {
  const datas = []
  const list = [
    'I', 'II', 'III', 'IY', 'Y', 'YI', 'YII', 'YIII', 'IX', 'X', 'XI', 'XII'
  ]
  list.map((list, idx) => {
    var data ={id: idx+1, name:list}
    datas.push(data)
  })
  return datas
}

/** Дотуур байранд амьдрах хүсэлт гаргасан оюутны шийдвэрийн төрөл  */
export const solved_type_color = (solved_flag) => {
  let color = ''
  let solved_flag_name = ''
  if (solved_flag === 1) {
      color = 'text-primary'
      solved_flag_name = 'ИЛГЭЭСЭН'
  }
  if (solved_flag === 2) {
      color = 'text-success'
      solved_flag_name = 'БАТАЛГААЖСАН'
  }
  else if (solved_flag === 3) {
      color = 'text-warning'
      solved_flag_name = 'БУЦААСАН'
  }
  else if (solved_flag === 4) {
    color = 'text-primary'
    solved_flag_name = 'ЗӨВШӨӨРСӨН'
  }
  else if (solved_flag === 5) {
    color = 'text-danger'
    solved_flag_name = 'ТАТГАЛЗСАН'
  }
  else if (solved_flag === 6) {
    color = 'text-danger'
    solved_flag_name = 'ЦУЦАЛСАН'
  }

  return (
      <span style ={{fontSize: 13}} className={`${color}`}>
          {
              solved_flag_name
          }
      </span>
  )
}

// Пар-аас хичээлийн эхлэх болон дуусах цагийг буцаана
export const get_time_name = (value) => {
    let start_time = ''
    let end_time = ''

    if (value === 1) {
        start_time = '08:00:00'
        end_time = '09:30:00'
    }
    else if (value === 2) {
        start_time = '09:40:00'
        end_time = '11:30:00'
    }
    else if (value === 3) {
        start_time = '11:40:00'
        end_time = '12:50:00'
    }
    else if (value === 4) {
        start_time = '13:20:00'
        end_time = '14:50:00'
    }
    else if (value === 5) {
        start_time = '15:00:00'
        end_time = '16:30:00'
    }
    else if (value === 6) {
        start_time = '16:40:00'
        end_time = '18:10:00'
    }
    else if (value === 7) {
        start_time = '18:20:00'
        end_time = '19:50:00'
    }
    else if (value === 8) {
        start_time = '20:00:00'
        end_time = '21:30:00'
    }

    var times = {
        start_time: start_time,
        end_time: end_time
    }

    return times
}

/** Хүснэгт хэвлэхэд ашиглах style */
export const printTableBody = `
    body
    {
        font-family: Arial;
        font-size: 10pt;
    }
    table
    {
        border: 1px solid #ccc;
        border-collapse: collapse;
    }
    table th
    {
        background-color: #F7F7F7;
        color: #333;
        font-weight: bold;
    }
    table th, table td
    {
        padding: 5px;
        border: 1px solid #ccc;
    }
  `

/** File extension шалгах функц */
export const check_image_ext = (file) => {

  var check = false
  const image_extension = ['png', 'jpg' , 'jpeg', 'svg']

  var file_name = file.name
  const splitted = file_name.split(".")
  const ext = splitted[splitted.length - 1]

  if (image_extension.includes(ext)) {
    check = true
  }

  return check
}


/** Хүйсийн жагсаалт */
export const get_gender_list = () => {
  const datas = []
  const list = [
      'Эрэгтэй',
      'Эмэгтэй',
      'Бусад'
  ]
  list.map((list, idx) => {
    var data ={id: idx+1, name:list}
    datas.push(data)
  })
  return datas
}

/** Захиалгын төрлийн жагсаалт */
export const get_order_type_list = () => {
  const datas = []
  const list = [
    'Спорт заал',
    'Номын сан',
    'Бялдаржуулах төв',
    'Эмнэлэг'
  ]
  list.map((list, idx) => {
    var data ={id: idx+1, name:list}
    datas.push(data)
  })
  return datas
}

/** Өрөгдөлийн төрлийн жагсаалт */
export const get_complaint_list = () => {
  const datas = []
  const list = [
    'Түр чөлөө авах',
    'Сургуулиас гарах',
    'Түр чөлөөнөөс үргэлжүүлэн суралцах',
  ]
  list.map((list, idx) => {
    var data = { id: idx + 1, name: list }
    datas.push(data)
  })
  return datas
}

export const request_flag_color = (request_flag) => {
     let color = ''
        let request_flag_name = ''

        if(request_flag === 1){
            color = 'light-info'
            request_flag_name = 'Илгээсэн'
        }
        else if (request_flag === 2) {
            color = 'light-warning'
            request_flag_name = 'Цуцалсан'
        }
        else if (request_flag === 3) {
            color = 'light-success'
            request_flag_name = 'Зөвшөөрсөн'
        }
        else if (request_flag === 4) {
          color = 'light-danger'
          request_flag_name = 'Татгалзсан'
        }

        return (
			 <Badge color={color}>
				{request_flag_name}
			 </Badge>
        )
    }

export const order_flag_datas = [
  {
    id: 1,
    name: 'Захиалсан'
  },
  {
    id: 2,
    name: 'Цуцалсан'
  },
]


/** Тойрох хуудас төрлийн жагсаалт */
export const get_routingslip_list = () => {
  const datas = []
  const list = [
    'Шилжиж явах',
    'Сургуулиас гарах',
    'Төгсөх',
  ]
  list.map((list, idx) => {
    var data = { id: idx + 1, name: list }
    datas.push(data)
  })

  return datas
}

export const solved_types = () =>
{
  const options = [
    { id: 1, name: 'ИЛГЭЭСЭН' },
    { id: 2, name: 'БУЦААСАН' },
    { id: 3, name: 'ЗӨВШӨӨРСӨН' },
    { id: 4, name: 'ТАТГАЛЗСАН' },
  ]

  return options
}

export const leave_types = () =>
{
  const options = [
    { id: 2, name: 'Cарын чөлөө' },
    { id: 3, name: 'Хоногийн чөлөө' },
  ]

  return options
}

/** Natural тоо эсэхийг шалгана */
export function isNaturalNumber(number)
{
  if (number)
  {
    number = number.toString();
    var n1 = Math.abs(number),
        n2 = parseInt(number, 10);
    return !isNaN(n1) && n2 === n1 && n1.toString() === number;
  }
  else
  {
    return false
  }
}

/** Дотуур байранд амьдрах хүсэлт гаргасан оюутны шийдвэрийн төрөл  */
export const get_solved_type = () => {
  const options = [
    { id: 1, name: 'ИЛГЭЭСЭН', color: 'primary' },
    { id: 2, name: 'Баталгаажсан',  color: 'success' },
    { id: 3, name: 'Буцаасан',  color: 'warning' },
    { id: 4, name: 'Зөвшөөрсөн', color: 'primary' },
    { id: 5, name: 'Татгалзсан', color: 'danger' },
    { id: 6, name: 'Цуцалсан', color: 'danger' },
  ]

  return options
}

/** Өргөдплийн гарах шалтгаан */
export const get_cause = () => {
  const options = [
    { id: 1, name: 'Ар гэрийн'},
    { id: 2, name: 'Төлбөрийн боломжгүй'},
    { id: 3, name: 'Эрүүл мэндийн'},
    { id: 4, name: 'Цэргийн алба хаах'},
    { id: 5, name: 'Энэ мэргэжлээр суралцах сонирхолгүй'},
    { id: 6, name: 'Гадаад явах'},
    { id: 7, name: 'Бусад'},
  ]
  return options
}



/** 1 => 01 болгох Format */
export function zeroFill(number)
{
  return ('0' + number).slice(-2);
}


export const get_rombo_week = () => {
  const datas = []

  var add_data = {
  'id': 17,
  'name': 'Ерөнхий мэдээлэл'
  }

  datas.push(add_data)

  const list = [
    'I', 'II', 'III', 'IY', 'Y', 'YI', 'YII', 'YIII', 'IX', 'X', 'XI', 'XII', 'XIII', "XIV", 'XV', 'XVI'
  ]
  list.map((list, idx) => {
    var data ={ id: idx+1, name:list }
    datas.push(data)
  })

  return datas
}

/** Хичээлийн материал төрлийн жагсаалт */
export const get_materialtype_list = () => {

	const urls = [file, video, book, example, homework, news, exam]
	const datas = []
	const list = [
		'Хичээлийн лекц',
		'Видео хичээл',
		'Ном, сурах бичиг',
		'Жишиг хичээл',
		"Даалгавар",
		"Мэдээлэл",
        "Шалгалт"
	]
	list.map((list, idx) => {
		var data = {
			id: idx + 1,
			name: list,
			url: urls[idx]
		}
		datas.push(data)
	})

	return datas
}

export const get_repayOption = () => {
  const options = [
    { id: 1, value: 100, name: 'Нийт төлбөр (100%)'},
    { id: 2, value: 50, name: 'Тухайн улирлын төлбөр (50%)'},
  ]
  return options
}

/**
 *
 * @param {Array} array - Жагсаалт
 * @param {String} key - груп хийх утга
 * @returns key-н дагуу груплээд буцаана
*/
export var groupBy = function(array, key) {
    return array.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};


// to check real existence of value (including 0 and false (this values are claimed as existing values))
export function isValuePresent(value) {
  if (
    value === null ||
    value === undefined ||
    value === "" ||
    Number.isNaN(value) ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === "object" && Object.keys(value).length === 0)
  ) {
      return false;
  }
  return true
}
